import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil, filter } from 'rxjs';
import { Router } from '@angular/router';
import { TeamManagementService } from '../team-management.service';
import { getCurrentQuarter } from '@utils/utils';

@Component({
  selector: 'app-team-management-action-items',
  templateUrl: './team-management-action-items.component.html',
  styleUrl: './team-management-action-items.component.scss',
})
export class TeamManagementActionItemsComponent implements OnInit, OnDestroy {
  totalReportess: number = 0;
  employeesWithFeedback: number = 0;
  showTeamDetailsModal: boolean = false;
  selectedProfileId: string | null = null;

  timesheetTitle = 'Timesheet';
  submittedCount: number | null = null;
  approvedCount: number | null = null;
  isTimesheetLoaded: boolean = false;

  private currentEmpId: string | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private teamManagementService: TeamManagementService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.teamManagementService
      .getSelectedDropdownValue()
      .pipe(
        takeUntil(this.destroy$),
        filter((selection) => selection !== null),
      )
      .subscribe((selection) => {
        this.currentEmpId = selection!.employeeId;
        this.loadActionItems(selection!.employeeId, selection!.filterType);
        this.fetchTimesheetStatusCount(selection!.employeeId, selection!.filterType);
      });
  }

  navigateToTimesheet(): void {
    this.router.navigate(['/vendor-management'], { state: { scrollToTimesheet: true } });
  }
  private fetchTimesheetStatusCount(employeeId: string, filterType?: string): void {
    this.isTimesheetLoaded = false;
    this.teamManagementService.getTimesheetStatusCount(employeeId, filterType).subscribe({
      next: (res) => {
        if (res?.status === 'SUCCESS' && res?.data) {
          this.submittedCount = res.data.submittedCount;
          this.approvedCount = res.data.approvedCount;
        }
        this.isTimesheetLoaded = true;
      },
      error: () => {
        this.isTimesheetLoaded = true;
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadActionItems(empId: string, filterType?: string): void {
    this.teamManagementService
      .getQuarterlyFeedbackCount(empId, getCurrentQuarter(), filterType)
      .subscribe((response) => {
        if (response?.data) {
          this.totalReportess = response?.data?.totalReportees;
          this.employeesWithFeedback = response?.data?.employeesWithFeedback;
        }
      });
  }

  navigateToTeamComposition(): void {
    this.selectedProfileId = null;
    this.showTeamDetailsModal = true;
  }

  closeTeamDetailsModal(): void {
    this.showTeamDetailsModal = false;
    this.selectedProfileId = null;
  }
}
